import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { LUCIDE_ICONS, LucideAngularModule, LucideIconProvider, icons } from 'lucide-angular';
import { AlertService } from './alert.service';
import { Alert } from './alert.model';
import { animate, style, transition, trigger } from '@angular/animations';
@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [LucideAngularModule, CommonModule],
  templateUrl: './alert.component.html',
  styles: ``,
  providers: [{ provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(icons) }],
  animations: [
    trigger('fadeSlide', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translate(-50%, 20px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translate(-50%, 0)' })),
      ]),
      transition(':leave', [animate('300ms ease-in', style({ opacity: 0, transform: 'translate(50%, 20px)' }))]),
    ]),
  ],
})
export class AlertComponent {
  showAlert: boolean = true;

  cssAlerts = {
    success:
      'text-green-500 border border-green-200 rounded-md md:items-center bg-green-50 dark:bg-green-400/20 dark:border-green-500/50',
    error:
      'text-red-500 border border-red-200 rounded-md md:items-center bg-red-50 dark:bg-red-400/20 dark:border-red-500/50',
    warning:
      'text-orange-500 border border-orange-200 rounded-md md:items-center bg-orange-50 dark:bg-orange-400/20 dark:border-orange-500/50',
  };

  private alertService = inject(AlertService);

  alert = signal<Alert>({ message: '', type: 'success', duration: 0, isVisible: false });

  constructor() {
    this.alertService.alert$.subscribe(this.alert.set);
  }
}
